import {CrudList, RolesEnum, SpecialtiesPreview, UserPreview} from 'app/Components'
import {Tabs} from 'app/Views/Groups'
import {rules} from 'lib/auth'
import {CrudAction, emptyFilterId, getRow, Type} from 'lib/crud'
import {Group, name as groupsName} from 'lib/groups'
import {name as groupTeacherName} from 'lib/groupTeacher'
import {State} from 'lib/store'
import {User} from 'lib/users'
import * as React from 'react'
import {connect, MapDispatchToProps, MapStateToProps} from 'react-redux'
import {RouteComponentProps, withRouter} from 'react-router-dom'

type StateToProps = {
    readonly group: Group
}

type DispatchToProps = {
    readonly load: (actionName: string, id: string) => void,
}

type Params = {
    parentId: string
}

const cols = [
    {
        id: "teacher",
        numeric: false,
        label: "Wychowawca",
        sort: false,
        template: (teacher: User) => <UserPreview id={teacher.id}/>
    },
    {
        id: "roles",
        numeric: false,
        label: "Rola",
        sort: false,
        width: '20%',
        template: (teacher: User) => <RolesEnum ids={teacher.roles} />
    },
    {
        id: "specialties",
        numeric: false,
        label: "Specjalizacje",
        sort: false,
        width: '40%',
        template: (teacher: User) => <SpecialtiesPreview ids={teacher.specialties}/>
    }
]

export class ListComponent extends React.Component<StateToProps & DispatchToProps & RouteComponentProps<Params>> {
    public componentDidMount(): void {
        if (this.props.match.params.parentId) {
            this.props.load(groupsName, this.props.match.params.parentId)
        }
    }

    public render = () => <>
        {this.props.group.id !== undefined ? <CrudList
            actionName={groupTeacherName}
            parentActionName={groupsName}
            cols={cols}
            selector={(state: State) => state.teachers}
            deleteDialogText="Usunąć wychowawcę?"
            rules={rules.groupTeachers}
            filter={{
                initialValues: {
                    id: this.props.group.id !== undefined && this.props.group.teachers.length > 0
                        ? this.props.group.teachers
                        : [emptyFilterId]
                },
                fields: []
            }}
            tabs={<Tabs id={this.props.match.params.parentId} />}
        /> : null}
    </>
}

const mapStateToProps: MapStateToProps<StateToProps, {}, State> = state => ({
    group: getRow(state => state.groups)(state),
})

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, {}> = dispatch => ({
    load: (actionName: string, id: string) => {
        dispatch(CrudAction.execute(actionName, Type.GET, {id}))
    },
})

export const List = withRouter(connect(mapStateToProps, mapDispatchToProps)(ListComponent))